import { useTranslation } from 'react-i18next'

import { Observation } from '../../types'
import { getAnnotationStatus } from '../../utils/observations'
import Tag from '../AnnotationStatusTag/Tag'
import useStyles from './ProductClassTag.styles'

const ProductClassTag = ({
  observation,
  hideIcon,
  iconOnly,
}: {
  observation: Observation
  hideIcon?: boolean
  iconOnly?: boolean
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const annotationStatus = getAnnotationStatus(
    observation.annotationValidation,
    observation.annotationClasses
  )

  const classTitle = `${t('Class')}: ${observation.productClasses.join(', ')}`

  return (
    <span className={classes.productClass} title={classTitle}>
      {annotationStatus
        ? {
            NOT_ANNOTATED: (
              <Tag
                title={classTitle}
                label={t('Not annotated')}
                appearance="empty"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
            ANNOTATED: (
              <Tag
                title={classTitle}
                label={observation.productClasses.join(', ')}
                appearance="valid"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
            EMPTY: (
              <Tag
                title={classTitle}
                label={t('Empty')}
                appearance="valid"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
            INVALID: (
              <Tag
                title={classTitle}
                label={t('Invalid')}
                appearance="invalid"
                hideIcon={hideIcon}
                iconOnly={iconOnly}
              />
            ),
          }[annotationStatus]
        : undefined}
    </span>
  )
}

export default ProductClassTag
